import { appCheck } from "../firebase";
import { getToken as getAppCheckToken, getLimitedUseToken } from "firebase/app-check";

/**
 * Recupera l'header X-Firebase-AppCheck e lo inietta opzionalmente in un apiClient
 * @param {Object} apiClient - opzionale, istanza di ApiClient
 * @returns {Promise<Object>} l'oggetto header { 'X-Firebase-AppCheck': '...' }
 */
export async function getAppCheckHeader(apiClient = null) {
    if (!appCheck) {
        return {};
    }
    try {
        const tokenResponse = await getAppCheckToken(appCheck);
        
        const header = { 'X-Firebase-AppCheck': tokenResponse.token };
        
        if (apiClient) {
            apiClient.defaultHeaders = {
                ...apiClient.defaultHeaders,
                ...header
            };
        }
        
        return header;
    } catch (err) {
        console.error("AppCheck error:", err);
        return {};
    }
}
